import React from 'react';

const Footer = () => {
  return (
    <div className="text-center">
      <hr style={{ height: '12px', color: 'red' }} />
      <p style={{ padding: '0px' }}>All Right Reserved 2021</p>
    </div>
  );
};

export default Footer;
